import React, { useEffect, useRef, useState, useContext } from "react";
import { MenuContext } from "../contexts/MenuContext";
import "./Header.css";
import FilterListIcon from "@mui/icons-material/FilterList";
import AppsIcon from "@mui/icons-material/Apps";
import SearchIcon from "@mui/icons-material/Search";

function Header() {
  const { setMenu, setExpanded, data, setData, order, setOrder } =
    useContext(MenuContext);
  const ref = useRef();
  const [isActive, setActive] = useState(false);

  // Sorting A-Z or by date
  const sorting = (col) => {
    if (order == "ASC") {
      const sorted = [...data].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
      );
      setData(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...data].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
      );
      setData(sorted);
      setOrder("ASC");
    }
  };

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    // const newFilter = ;
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (isActive && ref.current && !ref.current.contains(e.target)) {
        setActive(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isActive]);
  const ToggleClass = () => {
    setActive(!isActive);
    console.log("class toggled");
  };

  // Open Menu for filters and close expanded
  const openMenu = () => {
    setMenu("opened");
    setExpanded(false);
  };

  const closeExpanded = () => {
    setExpanded(false);
  };

  return (
    <div className="Header">
      <div className={`dropdown ${isActive ? "active" : null}`} ref={ref}>
        <button onClick={ToggleClass} className="header--filter">
          <FilterListIcon style={{ fill: "#ffffff" }} fontSize="large" />
        </button>
        <div className="dropdown--menu">
          <a href="#" onClick={() => sorting("title")}>
            AtoZ
          </a>
          <a href="#">Date</a>
        </div>
      </div>
      <div className="search--container">
        <input
          type="text"
          className="search"
          placeholder="Search..."
          onFocus={closeExpanded}
          onChange={handleFilter}
        />
        <div className="search--icon">
          <SearchIcon style={{ fill: "#ffffff" }} />
        </div>
      </div>
      <button className="header--menu" onClick={openMenu}>
        <AppsIcon style={{ fill: "#ffffff" }} fontSize="large" />
      </button>
    </div>
  );
}

export default Header;
